import styled from 'styled-components';

export const StyledMain = styled.main`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: var(--main-height);

  & > div {
    flex-grow: 1;
    display: flex;
    max-height: 100%;
  }
`;
